import { createContext } from "react";

export const LibraryStoreContext = createContext(null);
